import { render, staticRenderFns } from "./App.vue?vue&type=template&id=2f301902&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\happyboxstore-repo\\gift-activity\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f301902')) {
      api.createRecord('2f301902', component.options)
    } else {
      api.reload('2f301902', component.options)
    }
    module.hot.accept("./App.vue?vue&type=template&id=2f301902&", function () {
      api.rerender('2f301902', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "GiftActivity/App.vue"
export default component.exports